import { ErrorBoundary } from 'Common/common-ui';
import { logFrontendError } from 'Common/services/api';
import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';

const AppHeader: React.FC = () => {
  return (
    <Box
      id="sql-content-container"
      sx={{
        display: 'flex',
        flex: 1,
      }}
    >
      <ErrorBoundary onError={logFrontendError}>
        <Outlet />
      </ErrorBoundary>
    </Box>
  );
};

export default AppHeader;
